<template>
  <v-dialog
    v-model="isOpen"
    width="650"
    @click:outside="$emit('close')"
  >
    <v-card class=" py-6">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center pb-6">Relatório de Campo</v-card-title>
      <v-card-text>
        <div class="col-md-12">
          <v-select
            outlined
            :items="computedFilters"
            item-text="title"
            item-value="value"
            v-model="sort_by"
            label="Filtrar por"
          ></v-select>
        </div>
        <div class="col-md-12 d-flex">
          <v-checkbox
            label="Ordem Ascendente"
            class="pr-4"
            v-model="order.asc"
          ></v-checkbox>

          <v-checkbox
            label="Ordem Decrescente"
            v-model="order.desc"
          ></v-checkbox>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn class="success" @click="submit">Gerar Relatório</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import openAuthenticatedPdf from "@/http/openPdf";

export default {
  name:"ModalFieldReport",
  props:{
    isOpen:Boolean,
    service:Object
  },
  data() {
    return {
      order:{
        asc:true,
        desc:false
      },
      sort_by:"name"
    }
  },
  computed: {
    computedFilters() {
      return [
        {title:"Nome do animal", value:"name"},
        {title:"Botton", value:"code"},
        {title:"Registro", value:"register"},
      ]
    }
  },
  methods: {
    submit() {
      const url = `${process.env.VUE_APP_URL_API}/v1/services/${this.service.id}/pdf?sort_by=${encodeURIComponent(this.sort_by)}&order=${this.order.asc ? "asc" : "desc"}`
      openAuthenticatedPdf(url).catch(() => this.$toast.error("Não foi possível abrir o PDF"))
    }
  },
  watch: {
    "order.asc": function(val) {
      if(val) {
        this.order.desc = false;
      }
    },
    "order.desc": function(val) {
      if(val) {
        this.order.asc = false;
      }
    }
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>
